import Task from './components/Task'
import './App.css';

const App=()=>(
  <Task/>
)
export default App;
